import RPCert from "./certificate";
import RPTranscript from "../common/transcript2006";

const templates = [
  {
    id: "certificate",
    label: "Certificate",
    template: RPCert
  },
  {
    id: "transcript",
    label: "Transcript",
    template: RPTranscript
  }
];

export default templates;
